import { combineReducers } from 'redux';
import EcommerceReducer from './EcommerceReducer';
import NavigationReducer from './NavigationReducer';
import NotificationReducer from './NotificationReducer';
import DashboardReducer from './DashboardReducer';
import { PayRollReducer } from './PayRollReducer';
import { InboxReducer } from './InboxReducer';

const RootReducer = combineReducers({
  notifications: NotificationReducer,
  navigations: NavigationReducer,
  ecommerce: EcommerceReducer,
  dashboard: DashboardReducer,
  payRoll: PayRollReducer,
  inbox: InboxReducer,
});

export default RootReducer;
